module.exports = __webpack_public_path__ + "59dfa7a54c26dbde2e3b7e0fd65b6988.gif";